import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, of } from 'rxjs';

export interface DialogOption {
  id: string;
  labelKey: string;
  labelParams?: Record<string, unknown>;
}

@Component({
  selector: 'app-options-dialog',
  templateUrl: './options-dialog.component.html',
  styleUrls: ['./options-dialog.component.scss']
})
export class OptionsDialogComponent {

  title: string;
  message: string;
  options: { id: string; label: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<OptionsDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService) {
    const rawOptions: DialogOption[] = data.options || [];
    forkJoin({
      title: this.translate.get(data.title || 'confirmation'),
      message: this.translate.get(data.message || 'areYouSure', data.messageParams),
      labels: rawOptions.length
        ? forkJoin(rawOptions.map(option => this.translate.get(option.labelKey, option.labelParams)))
        : of([] as string[])
    }).subscribe(({ title, message, labels }) => {
      this.title = title;
      this.message = message;
      this.options = rawOptions.map((option, index) => ({ id: option.id, label: labels[index] }));
    });
  }

}
